<h2>Change vs PY over the last 12 months</h2>
<lib-interaction-message
  tapMessage="Tap any metric for a detailed breakdown."
  clickMessage="Click on any metric to see breakdown by relevant dimensions."
/>

<div class="trend-tiles">
  <lib-cubes-manager
    data-test="kpi-grid"
    [dataModel]="focusMeasures()"
  >
    <lib-cube
      class="tile"
      [class.is-loading]="isLoading()"
      data-test="tile"
      *cubeTemplate="focusMeasures(); let measure"
    >
      @if (dataChunk(); as chunk) {
        <div
          *libCubeFace
          class="tile-face"
          (click)="onChangeFocusMeasure(measure)"
        >
          <header class="tile-header">
            <h3>{{ measure.shortName }}</h3>

            @if (measure === focusMeasure()) {
              <svg viewBox="0 0 16 16" width="16" height="16">
                <use [attr.xlink:href]="SvgSpriteIcon.Eye"></use>
              </svg>
            }
          </header>

          <lib-l12m-bar-chart
            [dataPoints]="chunk.dataPoints"
            [growthMeasure]="measure.impactMeasure"
            [period]="periodCode()"
            [date]="date()"
          />
        </div>
      }
    </lib-cube>
  </lib-cubes-manager>
</div>
